export const level = {
    "100sShort": "100번대",
    "200sShort": "200번대",
    "300sShort": "300번대",
    "400sShort": "400번대",
    "500sShort": "500번대",
    "600sShort": "600번대",
    "700sShort": "700번대",
    "800sShort": "800번대",
    "900sShort": "900번대",
    etcShort: "기타",
}
